import React, { useEffect, useState, useRef } from "react";
import { FlightFareRule } from "../../Services/API";

const FareRule = ({
  load,
  clientCode,
  keyValue,
  supplierCode,
  departAirportCode,
  arrivalAirportCode,
  resultIndex,
  flight,
  sessionID, index
}) => {
  const [loading, setLoading] = useState(false);
  const [fareRuleData, setFareRuleData] = useState(null);
  const [error, setError] = useState(null);

  const hasFetched = useRef(false);
  useEffect(() => {
    if (!load || !resultIndex) return;
    if (!load || index === null || index === undefined) return;
    if (hasFetched.current) return;

    hasFetched.current = true;
    fetchFareRule();
  }, [
    load,
    resultIndex,
    clientCode,
    keyValue,
    supplierCode,
    departAirportCode,
    arrivalAirportCode,
    sessionID,
    flight,
  ]);

  const fetchFareRule = async () => {
    try {
      setLoading(true);
      setError(null);
      const requestBody = {
        clientCode,
        key: keyValue,
        supplierCode: flight?.sCode || supplierCode || "",
        origin: departAirportCode,
        destination: arrivalAirportCode,
        resultIndex: flight?.itemNo || resultIndex,
        sessionID,
        supSource: flight?.supSource || "",
        fareUniqueKey: flight?.fares?.[index]?.fareUniqueKey,
      };

      console.log("Fare Rule Request Body:", requestBody);
      const response = await FlightFareRule(requestBody);
      console.log("Fare Rule Response =>", response);
      if (response?.status !== "Success") {
        throw new Error(response?.error || "API returned failure");
      }
      setFareRuleData(response);
    } catch (err) {
      console.error("Fare Rule API Error:", err);
      console.error("Server Error:", err?.response?.data);
      //setError("Failed to load fare rules.");
    } finally {
      setLoading(false);
    }
  };

  if (!load) return null;

  return (
    <div className="p-3">

      {/* Loader */}
      {loading && (
        <p className="text-center">
          <span className="loader"></span>
        </p>
      )}

      {/* Fare Rule HTML Response */}
      {!loading && fareRuleData?.response && (
        <div
          className="fare-rule-html"
          dangerouslySetInnerHTML={{
            __html: fareRuleData.response,
          }}
        />
      )}
      {/* Data */}
      {!loading && fareRuleData && (
        <div>
          {/* Basic Fare Info */}
          <div className="mb-4">
            <h5 className="mb-2">{fareRuleData?.miniFareRule?.airline}</h5>
            {fareRuleData?.miniFareRule?.fareType && (
              <p><strong>Fare Type:</strong> {fareRuleData.miniFareRule.fareType}</p>
            )}

            {fareRuleData?.miniFareRule?.travelType && (
              <p><strong>Travel Type:</strong> {fareRuleData.miniFareRule.travelType}</p>
            )}

            {fareRuleData?.miniFareRule?.cabinClass && (
              <p><strong>Cabin Class:</strong> {fareRuleData.miniFareRule.cabinClass}</p>
            )}

            {fareRuleData?.miniFareRule?.refundableIndicator && (
              <p><strong>Refundable:</strong> {fareRuleData.miniFareRule.refundableIndicator}</p>
            )}
          </div>

          {/* Cancellation Rules */}
          <div className="mb-4">
            <h6 className="mb-3">Cancellation Charges</h6>

            {fareRuleData?.miniFareRule?.cancellations?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>Time Duration</th>
                      <th>Fee</th>
                      {/* <th>Child</th>
                      <th>Infant</th> */}
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fareRuleData?.miniFareRule?.cancellations.map((item, index) => (
                      <tr key={index}>
                        <td>{item.timeDuration}</td>
                        <td>
                          {item.adultCharge === 0
                            ? "Free"
                            : `${item.currency} ${item.adultCharge}`}
                        </td>
                        {/* <td>
                          {item.childCharge === 0
                            ? "Free"
                            : `${item.currency} ${item.childCharge}`}
                        </td>
                        <td>
                          {item.infantCharge === 0
                            ? "Free"
                            : `${item.currency} ${item.infantCharge}`}
                        </td> */}
                        <td>{item.ruleText || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>No Cancellation Rules Available</p>
            )}
          </div>

          {/* Reschedule Rules */}
          <div className="mb-4">
            <h6 className="mb-3">Reschedule Charges</h6>

            {fareRuleData?.miniFareRule?.reschedules?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>Time Duration</th>
                      <th>Adult</th>
                      <th>Child</th>
                      <th>Infant</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fareRuleData.miniFareRule.reschedules.map((item, index) => (
                      <tr key={index}>
                        <td>{item.timeDuration}</td>
                        <td>
                          {item.adultCharge === 0
                            ? "Free"
                            : `${item.currency} ${item.adultCharge}`}
                        </td>
                        <td>
                          {item.childCharge === 0
                            ? "Free"
                            : `${item.currency} ${item.childCharge}`}
                        </td>
                        <td>
                          {item.infantCharge === 0
                            ? "Free"
                            : `${item.currency} ${item.infantCharge}`}
                        </td>
                        <td>{item.ruleText || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>No Reschedule Rules Available</p>
            )}
          </div>

          {/* No Show Fee */}
          <div className="mb-4">
            <h6 className="mb-3">No Show Fee</h6>

            {fareRuleData?.miniFareRule?.additionalRules && (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>Time Duration</th>
                      <th>NO SHOW Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{fareRuleData?.miniFareRule?.noShowTimeDuration}</td>
                      <td>{fareRuleData?.miniFareRule?.additionalRules || "-"}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="mb-4">
            <h6 className="mb-3">Seat Chargeable Fee</h6>

            {fareRuleData?.miniFareRule?.seatRuleText && (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>Time Duration</th>
                      <th>Seat Chargeable Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{fareRuleData?.miniFareRule?.seatTimeDuration}</td>
                      <td>{fareRuleData?.miniFareRule?.seatRuleText || "-"}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Baggage Info */}
          {/* <div className="mb-4">
            <h6 className="mb-3">Baggage Information</h6>

            <p>
              <strong>Check-in Baggage (Adult):</strong>{" "}
              {fareRuleData?.checkinBaggageAdult} Kg (
              {fareRuleData?.checkinBaggagePiecesAdult} Pc)
            </p>

            <p>
              <strong>Hand Baggage (Adult):</strong>{" "}
              {fareRuleData?.handBaggageAdult} Kg (
              {fareRuleData?.handBaggagePiecesAdult} Pc)
            </p>
          </div> */}

        </div>
      )}
      {/* No Data */}
      {/* {!loading && !fareRuleData?.miniFareRule && !error && (
        <p>No Fare Rules Available</p>
      )} */}
    </div>

  );
};

export default FareRule